export enum LineOfBusiness {
  COMMERCIAL = "Commercial",
  MEDICAID = "Medicaid",
  MEDICARE = "Medicare",
  MEDICARE_RX = "Medicare Rx",
}
